module.exports = __webpack_public_path__ + "static/media/CyberLogovo_5_t.dd740f14.jpg";